<div class="container">
  <div class="language-toggle">
    <button (click)="setLanguage('is')" [class.active]="language === 'is'">Íslenska</button>
    <button (click)="setLanguage('en')" [class.active]="language === 'en'">English</button>
  </div>

  <div class="text-center" style="margin: 20px 0;">
    <img src="https://ello-bucket.s3.amazonaws.com/ello/6407d3b9a083250fe818445f43df85f2630f72db.svg" alt="">
  </div>

  <div *ngIf="language === 'is'">
    <h1>Stuðningur</h1>
    <p>Högnun slf. (Kt: 4410110910)</p>
    <p>Reykjavík, Ísland</p>
    <p>06. júlí 2024</p>
    <p>Velkomin(n) á stuðningssíðu Ello. Við erum hér til að aðstoða þig með allar spurningar eða vandamál sem þú gætir haft varðandi vefsíðuna okkar (ello.is) eða farsímaforritið okkar (App). Vinsamlegast lestu upplýsingarnar hér að neðan til að fá hjálp, og ef þú finnur ekki svarið sem þú leitar að, hafðu samband við okkur beint.</p>
    
    <h2>Hvernig við getum aðstoðað</h2>
    <p>Stuðningsteymið okkar er tilbúið til að hjálpa þér með ýmsar þarfir, svo sem:</p>
    <ul>
      <li>Tæknileg vandamál, svo sem innskráningarvandamál, villur í forriti, eða vandamál með aðgang að vefsíðunni okkar.</li>
      <li>Spurningar um reikninginn þinn, þar á meðal stofnun reiknings, uppfærslu upplýsinga, eða endurheimt lykilorðs.</li>
      <li>Upplýsingar um greiðslur, endurgreiðslur, eða áskriftir.</li>
      <li>Almennar spurningar um hvernig á að nota vefsíðuna okkar eða appið, þar á meðal eiginleika og virkni.</li>
      <li>Endurgjöf og tillögur til að bæta þjónustu okkar.</li>
    </ul>

    <h2>Hafðu samband við okkur</h2>
    <p>Ef þú þarft frekari aðstoð, vinsamlegast hafðu samband við stuðningsteymið okkar:</p>
    <ul>
      <li><strong>Tölvupóstur:</strong> Sendu tölvupóst á <a href="mailto:support@ello.is">support@ello.is</a>. Við svörum innan 48 klukkustunda.</li>
      <li><strong>Sími:</strong> Hringdu í okkur í +354 123 4567 (Mánudaga til föstudaga, 9:00-17:00).</li>
      <li><strong>Spjall í forriti:</strong> Notaðu spjallmöguleikann í farsímaforritinu okkar til að fá skjóta aðstoð.</li>
    </ul>
    <p>Vinsamlegast gefðu upp eins miklar upplýsingar og mögulegt er, svo sem lýsingu á vandamálinu, tækið sem þú notar, og reikningsupplýsingar þínar, til að við getum aðstoðað þig eins fljótt og auðið er.</p>

    <h2>Breytingar á stuðningi</h2>
    <p>Þessi stuðningssíða var birt 08. október 2024 og var síðast uppfærð þá. Við gætum breytt þessum upplýsingum af og til, og ef við gerum það, munum við tilkynna þér með tölvupósti.</p>
  </div>

  <div *ngIf="language === 'en'">
    <h1>Support</h1>
    <p>Högnun slf. (Reg. No: 4410110910)</p>
    <p>Reykjavík, Iceland</p>
    <p>July 06, 2024</p>
    <p>Welcome to Ello's support page. We are here to assist you with any questions or issues you may have regarding our website (ello.is) or our mobile application (App). Please read the information below to find help, and if you cannot find the answer you're looking for, contact us directly.</p>
    
    <h2>How We Can Help</h2>
    <p>Our support team is ready to assist you with various needs, such as:</p>
    <ul>
      <li>Technical issues, such as login problems, app errors, or issues accessing our website.</li>
      <li>Questions about your account, including account creation, updating information, or password recovery.</li>
      <li>Information about payments, refunds, or subscriptions.</li>
      <li>General questions about how to use our website or app, including features and functionality.</li>
      <li>Feedback and suggestions to improve our services.</li>
    </ul>

    <h2>Contact Us</h2>
    <p>If you need further assistance, please reach out to our support team:</p>
    <ul>
      <li><strong>Email:</strong> Send an email to <a href="mailto:support@ello.is">support@ello.is</a>. We respond within 48 hours.</li>
      <li><strong>Phone:</strong> Call us at +354 123 4567 (Monday to Friday, 9:00 AM-5:00 PM).</li>
      <li><strong>In-App Chat:</strong> Use the chat feature in our mobile app for quick assistance.</li>
    </ul>
    <p>Please provide as much detail as possible, such as a description of the issue, the device you are using, and your account information, so we can assist you as quickly as possible.</p>

    <h2>Changes to Support</h2>
    <p>This support page was published on October 08, 2024, and last updated on that date. We may update this information from time to time, and if we do, we will notify you via email.</p>
  </div>
</div>

<style>
  .container {
    max-width: 800px;
    margin: 0 auto;
    padding: 20px;
    font-family: Arial, sans-serif;
  }

  .language-toggle {
    margin-bottom: 20px;
    text-align: right;
  }

  .language-toggle button {
    background: #a7b59b;
    color: #fff;
    border: none;
    padding: 8px 16px;
    border-radius: 8px;
    cursor: pointer;
    font-weight: 500;
    transition: opacity 0.2s ease-in-out;
    margin-left: 10px;
  }

  .language-toggle button:first-child {
    margin-left: 0;
    /* no extra space before the first button */
  }

  .language-toggle button.active {
    background-color: #7b8873;
    color: white;
  }
</style>